import { useRollbar } from '@openx/utils/hooks/rollbarIntegration/useRollbar';
import { useMemo } from 'react';
import type { ParsedOpenXAgentWidget } from './widgetPayload';

export const useParsedWidget = <T>(
  payload: unknown,
  parse: (raw: unknown) => ParsedOpenXAgentWidget<T>,
  widgetName: string
): ParsedOpenXAgentWidget<T> => {
  const { rollbar } = useRollbar();

  return useMemo(() => {
    const parsed = parse(payload);
    if (!parsed.ok) {
      // biome-ignore lint/suspicious/noConsole: logging error in console
      console.error(widgetName, parsed.error);
      rollbar?.error(parsed.error);
    }
    return parsed;
  }, [payload, parse, widgetName, rollbar]);
};
